import { useFormContext } from "react-hook-form";
import { getFromStatisticsAdsCampaign } from "../../../../../services/adsCampaigns";
import { LINKEDIN } from "../../../../../utils/constants";
import {
  VALUE_NUMBER,
  VALUE_WITH_PERCENTAGE,
  ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP,
  IMPRESSIONS,
  RESULTS,
  CTR,
  CLICKS,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { openLink } from "../../../../../utils/string";
import Grid from "@mui/material/Grid";
import React from "react";
import _ from "lodash";
import PerformingAssetsCard from "../components/PerformingAssetsCard";

const LinkedInPerformingAssets = () => {
  const { t } = useTranslationApp();
  const { campaign, campaignID } = useFormContext();
  const { statistics } = getFromStatisticsAdsCampaign(campaign);

  // Returns the best assets group, prioritizing mainAction, otherwise by click
  const getBestAssetsGroup = (assetsGroupsStatistics) => {
    if (!assetsGroupsStatistics) return null;

    let bestByMainAction = null;
    let bestByClick = null;
    let hasMainAction = false;

    Object.entries(assetsGroupsStatistics).forEach(([assetsGroupId, stats]) => {
      if (stats.mainAction && stats.mainAction > 0) {
        hasMainAction = true;
        if (
          !bestByMainAction ||
          stats.mainAction > bestByMainAction.statistics.mainAction
        ) {
          bestByMainAction = {
            assetsGroupId,
            statistics: stats,
          };
        }
      }
      if (
        !bestByClick ||
        (stats.click || 0) > (bestByClick.statistics.click || 0)
      ) {
        bestByClick = {
          assetsGroupId,
          statistics: stats,
        };
      }
    });

    return hasMainAction ? bestByMainAction : bestByClick;
  };

  const bestAssetsGroup = getBestAssetsGroup(statistics[LINKEDIN].assetsGroups);

  const getAssetsGroupByID = (id) => {
    if (!id) {
      return {};
    }
    const assetsGroup = campaign.assetsGroups.find(
      (assetsGroup) => assetsGroup.id === id
    );
    if (!assetsGroup) {
      return {};
    }
    return { assetsGroup, assetsGroupID: assetsGroup?.id };
  };

  const { assetsGroup = {}, assetsGroupID } = getAssetsGroupByID(
    bestAssetsGroup?.assetsGroupId
  );

  const bestAssetsGroupStats = !_.isEmpty(bestAssetsGroup)
    ? [
        {
          label: t(IMPRESSIONS),
          value: t(VALUE_NUMBER, {
            value: bestAssetsGroup.statistics.impressions,
          }),
        },
        {
          label: t(CLICKS),
          value: t(VALUE_NUMBER, { value: bestAssetsGroup.statistics.click }),
        },
        {
          label: t(CTR),
          value: t(VALUE_WITH_PERCENTAGE, {
            value: bestAssetsGroup.statistics.ctr,
          }),
        },
        {
          label: t(RESULTS),
          value: t(VALUE_NUMBER, {
            value: bestAssetsGroup.statistics.mainAction,
          }),
        },
      ]
    : [];

  const insightCards = [
    !_.isEmpty(bestAssetsGroup) && (
      <PerformingAssetsCard
        key="bestAssetsGroup"
        platform={LINKEDIN}
        title={t(
          ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP
        )}
        subtitle={assetsGroup.name}
        onSubtitleClick={() =>
          openLink(
            `ads-campaign?campaignID=${campaignID}&platform=${LINKEDIN}&assetsGroupID=${assetsGroupID}`
          )
        }
        statistics={bestAssetsGroupStats}
      />
    ),
  ].filter(Boolean);

  const gridContent = (
    <Grid container spacing={2} alignItems="stretch">
      {insightCards.map((card, idx) => {
        return (
          <Grid
            item
            xs={12}
            sm={6}
            key={idx}
            sx={{ display: "flex", width: "100%" }}
          >
            {React.cloneElement(card, {
              sx: { ...card.props.sx, height: "100%", width: "100%" },
            })}
          </Grid>
        );
      })}
    </Grid>
  );

  return gridContent;
};

export default LinkedInPerformingAssets;
